<template>
  <v-app>
    <AppBar routeTo="login" btnName="Log in" />
    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="6" md="5">
          <v-card width="500" class="pa-4 custom-card" flat>
            <!-- Your card content goes here -->
            <v-form
              @submit.prevent="resetPassword"
              v-model="isFormValid"
              ref="form"
            >
              <div
                class="ml-4 mb-2 text-h6 text-md-h5 text-lg-h4 font-weight-bold font-theme"
              >
                Create a new password
              </div>
              <div class="ml-4 grey2--text mb-2">
                Please enter your new password
              </div>
              <v-card-text class="pb-0">
                <div class="mb-1 subtitle-2 grey3--text">Password</div>
                <v-text-field
                  v-model="password"
                  outlined
                  placeholder="Enter your password"
                  :rules="passwordRules"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : passwordFieldType"
                  @click:append="togglePasswordVisibility"
                  dense
                  prepend-inner-icon="mdi-lock"
                ></v-text-field>
                <div class="mb-1 subtitle-2 grey3--text">Confirm password</div>
                <v-text-field
                  v-model="passwordConfirm"
                  outlined
                  placeholder="Enter your password"
                  :rules="passwordConfirmRules"
                  :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPasswordConfirm ? 'text' : passwordFieldType"
                  @click:append="togglePasswordConfirmVisibility"
                  dense
                  prepend-inner-icon="mdi-lock"
                ></v-text-field>

                <v-btn
                  class="mt-2 primary white--text lowercase-text"
                  block
                  plain
                  :loading="$store.state.loading.resetBtn.load"
                  :disabled="$store.state.loading.resetBtn.disabled"
                  type="submit"
                >
                  Reset password
                </v-btn>
              </v-card-text>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import AppBar from "@/components/shared/AppBar";
export default {
  components: { AppBar },
  data() {
    return {
      password: null,
      showPassword: false,
      passwordConfirm: null,
      showPasswordConfirm: false,
      isFormValid: false,
      passwordFieldType: "password",
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => v.length >= 8 || "Password must be at least 8 characters",
        (v) =>
          /[A-Z]/.test(v) ||
          "Password must contain at least one uppercase letter",
        (v) =>
          /[!@#$%^&*(),.?":{}|<>]/.test(v) ||
          "Password must contain at least one special character",
      ],
      passwordConfirmRules: [
        (v) => !!v || "Password confirmation is required",
        (v) => v === this.password || "Passwords do not match",
      ],
    };
  },
  methods: {
    async resetPassword() {
      if (this.$refs.form.validate()) {
        // Form is valid, perform form submission or other actions
        const data = {
          token: this.$route.params.token,
          values: {
            password: this.password,
            passwordConfirm: this.passwordConfirm,
          },
        };
        await this.$store.dispatch("resetPassword", data);
        if (this.$store.state.user) {
          this.$router.push({ name: "stats" });
        }
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    togglePasswordConfirmVisibility() {
      this.showPasswordConfirm = !this.showPasswordConfirm;
    },
    routeToHandler() {
      this.$router.push({ name: "signup" });
    },
    forgotPassword() {
      this.$router.push({ name: "forgot-password" });
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.row-pointer {
  cursor: pointer;
  color: #2c5282;
}
.custom-card {
  /* Add your additional border radius values */
  border-radius: 20px;
}
</style>
